/* External */
import { all, fork } from "redux-saga/effects";

/* Sagas */
import filters from "./filters/sagas";
import stationsWithSchedules from "./stationsWithSchedules/sagas";

export default function* () {
  yield all([fork(filters)]);
  yield all([fork(stationsWithSchedules)]);
}
